var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobileNav02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#3C3E55;}\r\n\t.st1{display:none;fill:#20222E;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#3C3E55;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.9,89.7c35.1,0,70.1-0.1,105.2,0c20,0.1,32.2,10.5,32.4,27.1c0.2,16.6-12.2,27.5-32,27.6 c-71,0.1-142.1,0.1-213.1,0c-19.1,0-30.8-10.6-31-27.1c-0.2-16.4,11.8-27.4,30.6-27.5C186,89.6,222,89.7,257.9,89.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.9,185.2c35.1,0,70.2-0.1,105.2,0c19.9,0.1,32.3,10.6,32.4,27.1c0.1,16.7-12.2,27.6-31.9,27.6 c-71.1,0.1-142.1,0.1-213.2,0c-19.1,0-30.9-10.6-31-27.1c-0.2-16.4,11.8-27.5,30.5-27.6C186,185.1,222,185.2,257.9,185.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.7,335.5c-35.1,0-70.1,0.1-105.2,0c-20-0.1-32.1-10.6-32.1-27.4c0-16.9,12-27.3,32.2-27.3 c70.6-0.1,141.2-0.1,211.8,0c19.8,0,32.2,10.8,32.2,27.5c-0.1,16.6-12.4,27.2-32.3,27.2C327.8,335.6,292.3,335.5,256.7,335.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.9,118.2c-0.6,15.5-13.2,26.9-29,26.2c-14.9-0.7-26.5-13-26.3-27.8c0.2-15.3,12.9-27.2,28.6-26.8 C74,90.2,85.5,102.4,84.9,118.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.6,335.4c-15.7,0.1-28-11.9-27.9-27.4c0.1-15.3,12.6-27.4,28.3-27.1c15.2,0.3,26.8,11.7,27.1,26.8 C85.2,323.3,73.4,335.3,57.6,335.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.9,213.2c-0.3,15.7-12.6,27.3-28.5,26.8c-15.7-0.5-27.4-13-26.8-28.5c0.6-14.8,12.9-26.3,27.9-26.1 C73.4,185.4,85.2,197.4,84.9,213.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 212.6,
    cy: 212.6,
    r: 212.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.8,247.9c-4.4,4.6-8.8,9.1-13.3,13.6c-16,16.1-32.1,32.2-48.2,48.2c-9,9-24.1,8.9-33.3-0.2 c-9.1-9-9.2-24.1,0-33.2c20-20.1,40.1-40.1,60.1-60.1c0.4-0.4,0.8-0.9,1.6-1.8c-3.9-3.8-7.7-7.4-11.4-11.2 c-16.7-16.6-33.3-33.2-49.9-49.9c-6.6-6.6-8.8-14.7-6.1-23.7c2.6-8.8,8.6-14.4,17.6-16.3c8.6-1.8,16,0.7,22.3,6.9 c19.7,19.8,39.6,39.6,59.3,59.3c0.4,0.4,0.9,0.9,1.9,1.8c3.8-4,7.6-8,11.4-11.9c16.5-16.6,33.1-33.2,49.7-49.8 c9.2-9.2,24.2-9.3,33.3-0.4c9.4,9.3,9.6,24.2,0.2,33.6c-20.4,20.4-40.8,40.8-61.5,61.5c1.1,1.1,2.1,2.2,3.1,3.2 c19.4,19.4,38.8,38.8,58.2,58.2c6.7,6.7,8.8,14.9,6,24c-2.7,8.7-8.9,14.3-17.9,16c-8.6,1.6-16-1-22.2-7.3 c-19.7-19.8-39.4-39.5-59.1-59.2C215.1,249.1,214.7,248.6,213.8,247.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileNav02);
export default __webpack_public_path__ + "static/media/iconMobileNav02.5d8579673ea486bbe695e2d37c21ad6f.svg";
export { ForwardRef as ReactComponent };